module.exports = __webpack_public_path__ + "img/md.52933aba.svg";